import React, { useEffect, useState } from "react"
import { Grid, Typography } from "@mui/material"
import useStyles from "./useStyles"
import { getAllApplicationAppModule } from "../../../../app/services/eAuthz/getAllApplicationAppModuleEAuthz"
import { useDispatch } from "react-redux"
import { setErrorTextSnackBar, setRequestTextSnackBar } from "../../../../redux/actions/app"
import { EditModule } from "../Modals/EditModule"
import { DisabledModule } from "../Modals/DisabledModule"

export const BoxModules = ({ modules = [], appCode = "CGI", refresh, applicationInstanceId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [appicationModules, setappicationModules] = useState([])

  const getModulesByApp = async (appCode) => {
    try {
      const resp = await getAllApplicationAppModule(appCode)
      if (resp.data?.data?.appModules) {
        setappicationModules(resp.data?.data?.appModules)
      }
    } catch (error) {
      console.log(error)
      setappicationModules([])
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error al cargar los modulos de la aplicación."))
    }
  }
  const formatDate = (date) => {
    let formattedDate

    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getUTCDate() +
        "/" +
        (newDate.getUTCMonth() + 1) +
        "/" +
        newDate.getUTCFullYear()
    }

    return formattedDate
  }

  const getValue = (code) => {
    return modules?.find((m) => m.appModule === code)
  }

  useEffect(() => {
    if (appCode) getModulesByApp(appCode)
  }, [appCode])

  return (
    <Grid container className={classes.boxDetails}>
      <Grid
        item
        xs={12}
        style={{
          display: " flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#4B4952",
            paddingLeft: 10,
            width: '100%',
            borderBottom: "1px solid rgba(36, 55, 143, 0.2)",
          }}
        >
          Módulos habilitados
        </Typography>

      </Grid>
      {appicationModules && appicationModules.length > 0 &&
        appicationModules.map((item) => (
          <Grid key={item.appModuleId} container style={{ padding: 10 }}>
            <Grid item xs={8}>
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#485450",
                }}
              >
                {item.appModuleName}
              </Typography>
              <div style={{ display: "flex" }}>
                <Typography
                  style={{
                    fontSize: 13,
                    fontWeight: "bold",
                    color: "#6e7a76",
                  }}
                >
                  {getValue(item.appModule)?.startDate ? `Desde: ${formatDate(getValue(item.appModule)?.startDate)}` : "Desde: Fecha de inicio no configurada"}
                  {getValue(item.appModule)?.finishDate
                    ? `- Hasta: ${formatDate(getValue(item.appModule)?.finishDate)}`
                    : "- Hasta: Fecha de finalización no configurada"
                  }
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: 20
              }}
            >
              {!getValue(item.appModule) ? (
                <EditModule appCode={"CGI"} startDate={null} finishDate={null} applicationInstanceId={applicationInstanceId} module={item} isNewModule={!modules.find((i) => i.appModule === item.appModule)} refresh={refresh} />
              ) : getValue(item.appModule) &&
                getValue(item.appModule).finishDate &&
                new Date(getValue(item.appModule).finishDate) < new Date() ? (
                <>
                  <button className={classes.buttonEnabledModule}>
                    <Typography
                      className={classes.typographyButton}
                      style={{ color: "#6e7a76" }}
                    >
                      Deshabilitado
                    </Typography>
                  </button>
                  <EditModule module={item} startDate={getValue(item.appModule)?.startDate} finishDate={getValue(item.appModule).finishDate} applicationInstanceId={applicationInstanceId} isNewModule={!modules.find((i) => i.appModule === item.appModule)} refresh={refresh} />
                </>
              ) : (
                <>
                  <EditModule module={item} startDate={getValue(item.appModule)?.startDate} finishDate={getValue(item.appModule).finishDate} applicationInstanceId={applicationInstanceId} isNewModule={!modules.find((i) => i.appModule === item.appModule)} refresh={refresh} />
                  <DisabledModule module={item} applicationInstanceId={applicationInstanceId} refresh={refresh} />
                </>
              )}
            </Grid>
          </Grid>
        ))}
      {appicationModules && appicationModules.length === 0 &&
        (
          <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography
              style={{
                fontSize: 16,
                color: "#6e7a76",
                textAlign: "center",
                padding: "20px"
              }}
            >
              No hay módulos disponibles para esta aplicación
            </Typography>
          </Grid>
        )}
    </Grid>
  )
}
